import { render, staticRenderFns } from "./ConsultaPerfil.vue?vue&type=template&id=a4dfa950&"
import script from "./ConsultaPerfil.vue?vue&type=script&lang=js&"
export * from "./ConsultaPerfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports